import { BrandColors } from '../theme';

export const selectTokens = {
    root: {
        background: BrandColors.surface[0],
        borderColor: BrandColors.primary[200],
        hoverBorderColor: BrandColors.primary[400],
        focusBorderColor: BrandColors.primary[500],
        invalidBorderColor: BrandColors.red[500],
        color: BrandColors.surface[700],
        placeholderColor: BrandColors.surface[400],
        paddingX: '12px',
        paddingY: '12px',
        borderRadius: '4px',
        gap: '0.5rem',
    },
    option: {
        focusBackground: BrandColors.gray[100],
        focusColor: BrandColors.surface[900],
        selectedBackground: BrandColors.primary[500],
        selectedFocusBackground: BrandColors.primary[500],
        selectedColor: BrandColors.gray[0],
        selectedFocusColor: BrandColors.gray[0],
    },
    optionGroup: {
    color: BrandColors.semantic.text,
    fontWeight: '600',    
    }

};